import { render, staticRenderFns } from "./style-number-image.vue?vue&type=template&id=32447f2c&scoped=true"
import script from "./style-number-image.vue?vue&type=script&lang=js"
export * from "./style-number-image.vue?vue&type=script&lang=js"
import style0 from "./style-number-image.vue?vue&type=style&index=0&id=32447f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32447f2c",
  null
  
)

export default component.exports